export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";